import { useCallback } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import swtAlert from "lib/sweetAlert";
import { buildOfferingDocumentLocation } from "lib/investmentHelper";
import { selectIsAuthenticated } from "store/reducer";

/**
 * Starts the investment flow: offering document → risk acknowledgement → invest confirm.
 */
export function useNavigateToInvest({
  projectId,
  amount,
  minInvestment = 0,
  maxInvestment,
} = {}) {
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const navigate = useNavigate();

  const goToInvestPage = useCallback(() => {
    const returnTo = buildOfferingDocumentLocation(
      projectId,
      amount,
      minInvestment,
      maxInvestment
    );

    if (!isAuthenticated) {
      swtAlert.warning(
        "Sign in required",
        "Please sign in to invest in this campaign."
      );
      navigate("/sign-in", { state: { from: returnTo } });
      return;
    }

    navigate(returnTo);
  }, [
    projectId,
    amount,
    minInvestment,
    maxInvestment,
    isAuthenticated,
    navigate,
  ]);

  return { goToInvestPage };
}
